// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__AJMcC","sidebar":"Dashboard_sidebar__1HXjQ","wrapper":"Dashboard_wrapper__qYbXY","blur_container":"Dashboard_blur_container__qiI3A"};